export const AVAILABILITY_DATA_FETCH_RANGE_IN_MONTHS = 3;
